export default __webpack_public_path__ + "static/media/Execute.d515f8d9.png";